import { MyAccountForm } from './_my_account_form.component';
import { MyAccountRoot } from './_my_account_root.component';
import { MyAccountTitle } from './_my_account_title.component';

export const MyAccount = {
	Root: MyAccountRoot,
	Title: MyAccountTitle,
	Form: MyAccountForm,
} as const;
